var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.supportedLocales.length > 1
    ? _c(
        "div",
        { staticClass: "language-switcher", attrs: { id: _vm.id } },
        [
          _c("label", [_vm._v("Language")]),
          _c("v-select", {
            attrs: {
              attach: "#" + _vm.id,
              items: _vm.supportedLocales,
              "item-text": "title",
              "item-value": "name",
              "hide-details": "true",
              "menu-props": {
                contentClass: "language-switcher-list " + _vm.id,
                closeOnClick: true
              }
            },
            on: { change: _vm.changeLanguage },
            scopedSlots: _vm._u(
              [
                {
                  key: "selection",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("img", {
                        attrs: {
                          src: _vm.localeImage(item.icon),
                          alt: item.title
                        }
                      }),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.short === true ? item.name : item.title
                          )
                        }
                      })
                    ]
                  }
                },
                {
                  key: "item",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm.mustLocaleHaveLink(item)
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: _vm.localeLink(item), event: "" },
                              nativeOn: {
                                click: function($event) {
                                  $event.preventDefault()
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.localeImage(item.icon),
                                  alt: item.title
                                }
                              }),
                              _c("span", [_vm._v(_vm._s(item.title))])
                            ]
                          )
                        : _c("div", [
                            _c("img", {
                              attrs: {
                                src: _vm.localeImage(item.icon),
                                alt: item.title
                              }
                            }),
                            _c("span", [_vm._v(_vm._s(item.title))])
                          ])
                    ]
                  }
                }
              ],
              null,
              false,
              2567027388
            ),
            model: {
              value: _vm.locale,
              callback: function($$v) {
                _vm.locale = $$v
              },
              expression: "locale"
            }
          }),
          _vm.showBasicLinks
            ? _c(
                "div",
                { staticStyle: { display: "none" } },
                _vm._l(_vm.supportedLocales, function(locale) {
                  return _vm.mustLocaleHaveLink(locale)
                    ? _c("a", { attrs: { href: _vm.localeLink(locale) } }, [
                        _vm._v(
                          "\n            " + _vm._s(locale.title) + "\n        "
                        )
                      ])
                    : _vm._e()
                }),
                0
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }